import { ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getLorenzFormLayoutEnumString, LibFormValidityDotComponent, LorenzFormComponentDisplayOptions, LorenzFormComponentOptionsDefault, LorenzFormControl, LorenzFormGroup } from '@lib/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'lib-form-control-radio',
	imports: [CommonModule, FormsModule, ReactiveFormsModule, NgClass, LibFormValidityDotComponent, TranslateModule],
	templateUrl: './lib-form-control-radio.component.html',
	styleUrls: ['./lib-form-control-radio.component.scss']
})
export class LibFormControlRadioComponent implements OnInit {
	@Input({ required: true, alias: 'control' }) lorenzFormControl!: LorenzFormControl;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentDisplayOptions: LorenzFormComponentDisplayOptions = {};

	@HostBinding('attr.class') hostCssClass: string | null = null;

	public lorenzFormGroup!: LorenzFormGroup;

	public controlName = '';
	public controlFullKey = '';

	constructor(private cd: ChangeDetectorRef) {}

	public ngOnInit() {
		this.lorenzFormGroup = this.lorenzFormControl.parent as LorenzFormGroup;
		this.controlName = this.lorenzFormControl.getKey();
		this.controlFullKey = this.lorenzFormControl.getFullKey();

		this.lorenzFormControl.payload.displayOptions = this.lorenzFormComponentDisplayOptions;

		// prettier-ignore
		this.hostCssClass = [
				this.lorenzFormControl.getKey(),
				getLorenzFormLayoutEnumString(this.lorenzFormComponentDisplayOptions?.layout ?? null)
			].join(' ');

		this.lorenzFormControl.valueChanges.subscribe((data) => {
			this.cd.markForCheck();
		});

		// TODO setTimeout to quickfix "ExpressionChangedAfterItHasBeenCheckedError"
		setTimeout(() => {
			let initialValue = this.lorenzFormControl.value;
			if (!initialValue || initialValue === '') {
				initialValue = this.lorenzFormControl.getDefaultOption();
			}
			if (initialValue) {
				this.lorenzFormControl.setValue(initialValue);
			}
		}, 0);
	}

	get showErrorMessages(): boolean {
		return this.lorenzFormControl.showErrors() && (this.lorenzFormComponentDisplayOptions.showErrorMessages ?? LorenzFormComponentOptionsDefault.showErrorMessages);
	}

	readonlyHandler(event: MouseEvent) {
		if (this.lorenzFormControl?.isReadonly() || this.lorenzFormControl?.isLocked()) {
			event.preventDefault();
		}
	}
}
